import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["readonly"]

import { reactive, ref, onMounted, computed, watch } from "vue";
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomPhoneInput',
  props: {
        modelValue: { type: String, default: null },
        id: { type: String, required: true },
        classesNames: { type: String, default: '' },
        readonly: { type: Boolean, default: false }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {


    const props = __props;
    const emit = __emit;
    const formData = reactive({
        indicatif: '+225',
        telephone: null as string | null,
    });
    const countries = [
        { name: 'États-Unis', code: 'US', dial: '+1' },
        { name: 'Canada', code: 'CA', dial: '+1' },
        { name: 'Sénégal', code: 'SN', dial: '+221' },
        { name: 'Mali', code: 'ML', dial: '+223' },
        { name: 'Guinée', code: 'GN', dial: '+224' },
        { name: 'Côte d’Ivoire', code: 'CI', dial: '+225' },
        { name: 'Burkina Faso', code: 'BF', dial: '+226' },
        { name: 'Niger', code: 'NE', dial: '+227' },
        { name: 'Togo', code: 'TG', dial: '+228' },
        { name: 'Bénin', code: 'BJ', dial: '+229' },
        { name: 'Ghana', code: 'GH', dial: '+233' },
        { name: 'Nigeria', code: 'NG', dial: '+234' },
        { name: 'Rwanda', code: 'RW', dial: '+250' },
        { name: 'Éthiopie', code: 'ET', dial: '+251' },
        { name: 'Kenya', code: 'KE', dial: '+254' },
        { name: 'Tanzanie', code: 'TZ', dial: '+255' },
        { name: 'Afrique du Sud', code: 'ZA', dial: '+27' },
        { name: 'Belgique', code: 'BE', dial: '+32' },
        { name: 'France', code: 'FR', dial: '+33' },
        { name: 'Luxembourg', code: 'LU', dial: '+352' },
        { name: 'Suisse', code: 'CH', dial: '+41' },
        { name: 'Allemagne', code: 'DE', dial: '+49' },
        { name: 'Mexique', code: 'MX', dial: '+52' },
        { name: 'Brésil', code: 'BR', dial: '+55' },
        { name: 'Japon', code: 'JP', dial: '+81' },
        { name: 'Chine', code: 'CN', dial: '+86' },
        { name: 'Inde', code: 'IN', dial: '+91' },
        { name: 'Émirats Arabes Unis', code: 'AE', dial: '+971' },
    ];

    watch(props, () => {
        if (props.modelValue) {
            const fullNumber = props.modelValue as string;
            for (const country of countries) {
                if (fullNumber.startsWith(country.dial)) {
                    formData.indicatif = country.dial;
                    formData.telephone = fullNumber.slice(country.dial.length);
                    break;
                }
            }
        }
    }, { deep: true });

    
    watch(formData, () => {
        emit('update:modelValue', `${formData.indicatif}${formData.telephone}`);
    }, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-field-floating reactive form-field-with-prefix", props.classesNames])
  }, [
    _withDirectives(_createElementVNode("select", {
      class: "form-input-prefix",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.indicatif) = $event)),
      name: "indicatif",
      id: "indicatif"
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countries, (country) => {
        return _createElementVNode("option", {
          key: country.code,
          value: country.dial
        }, _toDisplayString(country.dial) + " (" + _toDisplayString(country.code) + ") ", 9, _hoisted_1)
      }), 64))
    ], 512), [
      [_vModelSelect, formData.indicatif]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "form-input",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.telephone) = $event)),
      name: "telephone",
      id: "telephone",
      placeholder: "",
      readonly: __props.readonly
    }, null, 8, _hoisted_2), [
      [_vModelText, formData.telephone]
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("label", { for: "telephone" }, [
      _createTextVNode("Téléphone "),
      _createElementVNode("b", { class: "color-danger" }, "*")
    ], -1))
  ], 2))
}
}

})